import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

export default function PhoneField({ inputClass, phone, setPhone }) {
    
  
    return (
    <div className="w-full rounded">
      <PhoneInput
        id="phone"
        defaultCountry="RU"
        placeholder="+7 999 123-45-67"
        value={phone}
        onChange={setPhone}
        className={inputClass}
      />
    </div>
  );
}
